// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.languageSpreadSheet {
    font-family: var(--font-family-base) !important;
    height: 500px !important;
    width: 100%;
    background-color: transparent !important;
}

.languageSpreadSheet .Spreadsheet__header,
.languageSpreadSheet .numberSection {
    background: var(--common-gray-bg-color) !important;
    color: var(--common-text-color) !important;
    border: none !important;
    text-align: left !important;
    padding: 6px 18px !important;
    white-space: normal !important;
    word-break: unset !important;
    font-weight: 600 !important;
}

.languageSpreadSheet .Spreadsheet__cell {
    border: none !important;
    white-space: normal !important;
    word-break: unset !important;
    padding: 6px 18px !important;
    color: var(--common-text-color) !important;
}

.languageSpreadSheet .Spreadsheet__cell:first-child,
.languageSpreadSheet .Spreadsheet__header:first-child {
    min-width: 111px;
    text-align: center !important;
    font-weight: normal !important;
    border-bottom: 1px solid var(--primary-border) !important;
    border-left: 0 !important;
    border-right: 0 !important;
}

.languageSpreadSheet .Spreadsheet__cell:nth-child(2),
.languageSpreadSheet .Spreadsheet__header:nth-child(2) {
    min-width: 278px;
    max-width: 500px;
    border: 1px solid var(--primary-border) !important;
    border-top: 0px !important;
}

.languageSpreadSheet .Spreadsheet__cell:nth-child(3),
.languageSpreadSheet .Spreadsheet__header:nth-child(3) {
    border-bottom: 1px solid var(--primary-border) !important;
    width: 100% !important;
}

.languageSpreadSheet .Spreadsheet__data-viewer {
    padding: 0px !important;
}

.languageSpreadSheet .Spreadsheet__table tbody tr:first-child {
    position: sticky;
    top: 0px;
    z-index: 1;
}

.languageSpreadSheet .Spreadsheet__cell,
.languageSpreadSheet .Spreadsheet__header {
    text-align: start !important;
}

.languageSpreadSheet .Spreadsheet__active-cell:not(.Spreadsheet__active-cell--edit) {
    border: unset !important;
}

.languageSpreadSheet .Spreadsheet__active-cell--edit {
    border: 1px solid var(--secondary-border);
    border-radius: 4px;
    box-shadow: 0px 4px 4px 0px #00000014;
    background: var(--common-gray-bg-color);
    color: var(--common-text-color);
}

.languageSpreadSheet .Spreadsheet__cell--readonly {
    cursor: not-allowed !important;
}

@media (max-width: 767px) {

    .languageSpreadSheet .Spreadsheet__cell:nth-child(3),
    .languageSpreadSheet .Spreadsheet__header:nth-child(3) {
        min-width: 278px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/spreadSheet.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;IAC/C,wBAAwB;IACxB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;;IAEI,kDAAkD;IAClD,0CAA0C;IAC1C,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;;IAEI,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;IAC9B,yDAAyD;IACzD,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;;IAEI,yDAAyD;IACzD,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,UAAU;AACd;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,qCAAqC;IACrC,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":[".languageSpreadSheet {\n    font-family: var(--font-family-base) !important;\n    height: 500px !important;\n    width: 100%;\n    background-color: transparent !important;\n}\n\n.languageSpreadSheet .Spreadsheet__header,\n.languageSpreadSheet .numberSection {\n    background: var(--common-gray-bg-color) !important;\n    color: var(--common-text-color) !important;\n    border: none !important;\n    text-align: left !important;\n    padding: 6px 18px !important;\n    white-space: normal !important;\n    word-break: unset !important;\n    font-weight: 600 !important;\n}\n\n.languageSpreadSheet .Spreadsheet__cell {\n    border: none !important;\n    white-space: normal !important;\n    word-break: unset !important;\n    padding: 6px 18px !important;\n    color: var(--common-text-color) !important;\n}\n\n.languageSpreadSheet .Spreadsheet__cell:first-child,\n.languageSpreadSheet .Spreadsheet__header:first-child {\n    min-width: 111px;\n    text-align: center !important;\n    font-weight: normal !important;\n    border-bottom: 1px solid var(--primary-border) !important;\n    border-left: 0 !important;\n    border-right: 0 !important;\n}\n\n.languageSpreadSheet .Spreadsheet__cell:nth-child(2),\n.languageSpreadSheet .Spreadsheet__header:nth-child(2) {\n    min-width: 278px;\n    max-width: 500px;\n    border: 1px solid var(--primary-border) !important;\n    border-top: 0px !important;\n}\n\n.languageSpreadSheet .Spreadsheet__cell:nth-child(3),\n.languageSpreadSheet .Spreadsheet__header:nth-child(3) {\n    border-bottom: 1px solid var(--primary-border) !important;\n    width: 100% !important;\n}\n\n.languageSpreadSheet .Spreadsheet__data-viewer {\n    padding: 0px !important;\n}\n\n.languageSpreadSheet .Spreadsheet__table tbody tr:first-child {\n    position: sticky;\n    top: 0px;\n    z-index: 1;\n}\n\n.languageSpreadSheet .Spreadsheet__cell,\n.languageSpreadSheet .Spreadsheet__header {\n    text-align: start !important;\n}\n\n.languageSpreadSheet .Spreadsheet__active-cell:not(.Spreadsheet__active-cell--edit) {\n    border: unset !important;\n}\n\n.languageSpreadSheet .Spreadsheet__active-cell--edit {\n    border: 1px solid var(--secondary-border);\n    border-radius: 4px;\n    box-shadow: 0px 4px 4px 0px #00000014;\n    background: var(--common-gray-bg-color);\n    color: var(--common-text-color);\n}\n\n.languageSpreadSheet .Spreadsheet__cell--readonly {\n    cursor: not-allowed !important;\n}\n\n@media (max-width: 767px) {\n\n    .languageSpreadSheet .Spreadsheet__cell:nth-child(3),\n    .languageSpreadSheet .Spreadsheet__header:nth-child(3) {\n        min-width: 278px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
